import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ToastIconTick = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9.00001 1.75C4.99595 1.75 1.75001 4.99593 1.75001 9C1.75001 13.0041 4.99595 16.25 9.00001 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99593 13.0041 1.75 9.00001 1.75ZM13.1049 4.77875C13.5234 5.07171 13.6252 5.64848 13.3322 6.06699L8.46894 13.0146C8.43087 13.0713 8.38587 13.1248 8.33398 13.1736C7.96197 13.5237 7.37656 13.506 7.02643 13.134L4.55911 10.5125C4.20899 10.1404 4.22673 9.55504 4.59874 9.20491C4.97075 8.85478 5.55616 8.87252 5.90628 9.24453L7.59429 11.038L11.8167 5.00609C12.1096 4.58757 12.6864 4.48579 13.1049 4.77875Z"
      fill="#006632"
    />
  </SvgIcon>
);

export default ToastIconTick;
